module.exports = __webpack_public_path__ + "static/media/icon-light.6a027051.png";